import { render, staticRenderFns } from "./BindAlipay.vue?vue&type=template&id=074207ee&scoped=true"
import script from "./BindAlipay.vue?vue&type=script&lang=js"
export * from "./BindAlipay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074207ee",
  null
  
)

export default component.exports